import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import MDButton from 'components/MDButton';
import CircularProgress from '@mui/material/CircularProgress';
import { getDiscountedPrice, MEMBERSHIP_PLANS } from './SignUpPage'; // Updated import

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const StripeButton = ({
  plan,
  discountInfo,
  activePromotion,
  email,
  fullName,
  password,
  isFormValid,
  setError,
  setLoading,
  navigate
}) => {
  const handleStripeCheckout = async () => {
    try {
      setLoading(true);
      setError(null);
  
      if (!email || !email.includes('@')) {
        setError('Valid email is required');
        return;
      }
      const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/;
      if (!password || !passwordRegex.test(password)) {
        setError('Password must be at least 8 characters and include at least one number and one special character (e.g., !@#$%^&*)');
        return;
      }
      if (!fullName) {
        setError('Full name is required');
        return;
      }
  
      const finalPrice = discountInfo ? getDiscountedPrice(plan.price, plan.id, discountInfo, activePromotion) : plan.price;
      let priceId = plan.stripePriceId;
  
      if (discountInfo?.type === 'percentage') {
        priceId = plan.id === 'monthly_plan' ?
          discountInfo.stripeMonthlyPriceId :
          discountInfo.stripeAnnualPriceId;
      } else if (activePromotion && activePromotion.appliesTo.includes(plan.id)) {
        priceId = plan.discountedPlans[activePromotion.discountValue]?.stripe;
      }
  
      const payload = {
        price_id: priceId,
        email,
        fullName,
        plan_id: plan.id,
        ...(discountInfo && {
          discount_code: discountInfo.code,
          discount_type: discountInfo.type,
          discount_value: parseInt(discountInfo.value, 10),
          final_price: finalPrice,
          is_trial_upgrade: discountInfo.isTrialUpgrade || false,
          teamId: discountInfo.teamId
        })
      };
  
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/create-stripe-checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
  
      const result = await response.json();
      if (result.error) throw new Error(result.message);
  
      // Fetch the checkout session to get the subscription ID
      const sessionResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/get-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId: result.sessionId })
      });
  
      const sessionData = await sessionResponse.json();
      if (sessionData.error) throw new Error(sessionData.error);
  
      const pendingSignup = {
        email,
        password,
        fullName,
        plan: discountInfo?.isTrialUpgrade ? MEMBERSHIP_PLANS.TRIAL_UPGRADE.id : plan.id,
        subscriptionID: sessionData.subscription || result.sessionId, // Use subscription ID if available
        discountCode: discountInfo ? discountInfo.code : null,
        discountInfo: discountInfo || null,
        teamId: discountInfo?.teamId || null,
        paymentMethod: 'stripe'
      };
  
      sessionStorage.setItem('pendingSignup', JSON.stringify(pendingSignup));
  
      const stripe = await stripePromise;
      await stripe.redirectToCheckout({ sessionId: result.sessionId });
  
    } catch (error) {
      console.error('Stripe checkout failed:', error);
      setError(error.message);
      setLoading(false);
    }
  };

  return (
    <MDButton
      variant="gradient"
      color="warning"
      fullWidth
      onClick={handleStripeCheckout}
      disabled={!isFormValid}
    >
      Subscribe with Stripe
    </MDButton>
  );
};

export default StripeButton;